/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Aggregator {
  STATE = 'STATE',
  RATING_AREA = 'RATING_AREA',
  NONE = 'NONE',
}
